import { StatusBar } from "expo-status-bar";
import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import Table from "./table";
import { useIsFocused } from "@react-navigation/native";
import { useRecoilState } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { apiservice } from "../../service/service";
const { width, height } = Dimensions.get("window");
export default function freepoint({ navigation }) {
  const focus = useIsFocused();
  const [token, setToken] = useRecoilState(tokenState);
  const [data, setdata] = useState([]);

  async function getAllfreepoint() {
    const response = await apiservice({
      path: "/freepoint/getAllfreepoint",
      method: "get",
      token: token?.accessToken,
    });
    if (response.status == 200) {
      setdata(response.data);
    }
  }
  useEffect(() => {
    getAllfreepoint();
  }, [focus]);
  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <View style={styles.back}>
        <Admin />
        <View style={styles.viewfree}>
          <Text style={styles.textfree}>FREE POINT</Text>
          <TouchableOpacity
            onPress={() => navigation.navigate("CreateFreepoint")}
            style={styles.touchadd}
          >
            <Text style={styles.textadd}>ADD</Text>
          </TouchableOpacity>
        </View>
        {data.length == 0 ? (
          <Text style={styles.textsum}>ไม่พบรายการ</Text>
        ) : (
          <Text style={styles.textsum}>
            มีจำนวนทั้งหมด {data.length} รายการ
          </Text>
        )}

        <Table
          data={data}
          navigation={navigation}
          onSuccess={getAllfreepoint}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: "85%",
    height: height,
    paddingHorizontal: "1%",
  },
  viewfree: {
    justifyContent: "space-between",
    width: "100%",
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 24,
    color: "#172B4D",
    alignSelf: "center",
  },
  textsum: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "flex-end",
    marginTop: 10,
  },
});
